import React, { PureComponent } from 'react';
import { arrayOf, func, string, number, shape, oneOfType } from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { Card, ChartEmptyState, DoughnutChart } from 'common/components';
import { ROUTE_FIELDS } from 'common/constants';
// import './index.css';

const emptyStateText = {
  chartTitle: 'Crops',
  title: 'You have not added any crops yet.',
  subTitle: 'start adding crops to your fields.',
  buttonText: 'Add Crops',
};

/**
 *
 *
 * @export
 * @class CropsChart
 * @extends {PureComponent}
 */
export class CropsChart extends PureComponent {
  static displayName = 'CropsChart';

  static propTypes = {
    data: arrayOf(
      shape({
        x: string,
        y: oneOfType([string, number]),
        unit: string,
      })
    ),
    goToFieldPage: func,
  };

  static defaultProps = {
    data: [],
  };

  render() {
    const { data, goToFieldPage } = this.props;
    // If there is no data, show empty state
    if (!data.length)
      return <ChartEmptyState {...emptyStateText} navigateTo={goToFieldPage} />;

    return (
      <Card
        header={<h2 className="text--header text--medium">Crops Planted</h2>}
        theme={['noborder']}
      >
        <DoughnutChart data={data} />
      </Card>
    );
  }

  /**
   *
   *
   * @memberof DoughnutChart
   * @param {Object} - data from graphql
   * Get crop names for the legend
   */
  _getCropNamesForLegend = data => data.map(({ x }) => x.split(' ')[0]);
}

const mapDispatchToProps = {
  goToFieldPage: () => push(ROUTE_FIELDS),
};

export default connect(
  null,
  mapDispatchToProps
)(CropsChart);



// WEBPACK FOOTER //
// ./src/containers/CropsChart/index.js